import axiosInstance from '../../config/axios.config';

const userManagementService = {
    // Get paginated user list with filters
    getUserList: async (params = {}) => {
        const token = localStorage.getItem('authToken');
        
        if (token) {
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        
        const response = await axiosInstance.get('/admin/users', { params });
        return response.data;
    },

    // Update user role
    updateUserRole: async (userId, roleData) => {
        const token = localStorage.getItem('authToken');
        
        if (token) {
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        
        const response = await axiosInstance.patch(`/admin/users/${userId}/role`, roleData);
        return response.data;
    },

    // Get available roles
    getAvailableRoles: async () => {
        const token = localStorage.getItem('authToken');
        
        if (token) {
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        
        const response = await axiosInstance.get('/admin/roles');
        return response.data;
    }
};

export default userManagementService;